export const ETasScenarioType = {
  "0": "UNKNOWN",
  "1": "HOTEL",
  "2": "FLIGHT",
  "3": "HOTEL_MULTIPLE_SEARCH",
  "4": "FLIGHT_BAGGAGE",
  "5": "FLIGHT_SEAT",
  "6": "ROOM_PRICE_PROCEDURE",
  "-1": "ALL"
};

export const ETasLogStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "PROCESSING",
  "3": "SUCCESS",
  "4": "FAIL",
  "-1": "ALL"
};